import { Icon } from "@/ds";
import type { LegendSwatchProps } from "./types-legend-swatch";

const PILL_COLORS = {
  planejamento: "var(--ds-color-blue-400)",
  obra: "var(--ds-color-primary-900)",
  fechamento: "var(--ds-color-green-400)",
} as const;

/** Amostra de cada item da legenda, desenhada como no protótipo (Figma, node 7651:179047). */
export function LegendSwatchView({ kind }: LegendSwatchProps) {
  if (kind === "planejamento" || kind === "obra" || kind === "fechamento") {
    return (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden>
        <path
          d="M5 11H17"
          style={{ stroke: PILL_COLORS[kind] }}
          strokeWidth="10"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (kind === "transferida") {
    return <Icon name="star" size={12} />;
  }

  if (kind === "cancelada") {
    return (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden>
        <path
          d="M1 11H21"
          style={{ stroke: "var(--ds-color-red-400)" }}
          strokeWidth="2"
          strokeDasharray="4 2"
          strokeLinecap="butt"
        />
      </svg>
    );
  }

  if (kind === "simulado") {
    return (
      <svg
        width="22"
        height="14"
        viewBox="0 0 22 14"
        preserveAspectRatio="none"
        fill="none"
        aria-hidden
      >
        <rect
          x="1"
          y="1"
          width="20"
          height="12"
          rx="6"
          style={{ fill: "var(--ds-color-orange-100)", stroke: "var(--ds-color-amber-600)" }}
        />
      </svg>
    );
  }

  if (kind === "simulado-preenchido") {
    return (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden>
        <path
          d="M5 11H17"
          style={{ stroke: "var(--ds-color-yellow-600)" }}
          strokeWidth="10"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (kind === "deslocamento") {
    return (
      <svg width="22" height="14" viewBox="0 0 22 14" fill="none" aria-hidden>
        <rect
          x="0.5"
          y="0.5"
          width="21"
          height="13"
          rx="2"
          strokeDasharray="3 2"
          style={{ fill: "var(--ds-color-orange-100)", stroke: "var(--ds-color-yellow-600)" }}
        />
      </svg>
    );
  }

  if (kind === "indisponibilidade") {
    return (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
        <circle cx="8" cy="8" r="8" style={{ fill: "var(--ds-color-gray-400)" }} />
        <g transform="translate(2 2)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6ZM6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM6.5 2.66667C6.5 2.39052 6.27614 2.16667 6 2.16667C5.72386 2.16667 5.5 2.39052 5.5 2.66667V6C5.5 6.27614 5.72386 6.5 6 6.5H8C8.27614 6.5 8.5 6.27614 8.5 6C8.5 5.72386 8.27614 5.5 8 5.5H6.5V2.66667Z"
            style={{ fill: "var(--ds-color-surface-0)" }}
          />
        </g>
      </svg>
    );
  }

  return (
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" aria-hidden>
      <circle cx="4" cy="4" r="4" style={{ fill: "var(--ds-color-gray-400)" }} />
      <rect x="3" y="5" width="2" height="9" style={{ fill: "var(--ds-color-gray-400)" }} />
    </svg>
  );
}
